/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Styles_Controls_Aria_LabelInputs */

const en_styles_controls_aria_label = /** @type {(inputs: Styles_Controls_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Style Controls`)
};

const fr_styles_controls_aria_label = /** @type {(inputs: Styles_Controls_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controles de style`)
};

const de_styles_controls_aria_label = /** @type {(inputs: Styles_Controls_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stilsteuerung`)
};

const it_styles_controls_aria_label = /** @type {(inputs: Styles_Controls_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controlli di stile`)
};

const ru_styles_controls_aria_label = /** @type {(inputs: Styles_Controls_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Элементы управления стилем`)
};

const es_styles_controls_aria_label = /** @type {(inputs: Styles_Controls_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controles de estilo`)
};

const zh_cn2_styles_controls_aria_label = /** @type {(inputs: Styles_Controls_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`样式控制`)
};

const ja_styles_controls_aria_label = /** @type {(inputs: Styles_Controls_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スタイルコントロール`)
};

const hi_styles_controls_aria_label = /** @type {(inputs: Styles_Controls_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शैली नियंत्रण`)
};

const pt_pt2_styles_controls_aria_label = /** @type {(inputs: Styles_Controls_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controles de estilo`)
};

/**
* | output |
* | --- |
* | "Style Controls" |
*
* @param {Styles_Controls_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const styles_controls_aria_label = /** @type {((inputs?: Styles_Controls_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Styles_Controls_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_styles_controls_aria_label(inputs)
	if (locale === "de") return de_styles_controls_aria_label(inputs)
	if (locale === "it") return it_styles_controls_aria_label(inputs)
	if (locale === "ru") return ru_styles_controls_aria_label(inputs)
	if (locale === "es") return es_styles_controls_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_styles_controls_aria_label(inputs)
	if (locale === "ja") return ja_styles_controls_aria_label(inputs)
	if (locale === "hi") return hi_styles_controls_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_styles_controls_aria_label(inputs)
	return en_styles_controls_aria_label(inputs)
});